// Social Media Links
export const SOCIAL_LINKS = {
  PUMP_FUN: 'https://pump.fun/coin/7TxMjWSsQ23wMrGdEx21A7q9K316h9LiHbzaYayDpump', // TODO: Update with actual pump.fun chart URL
  TWITTER: 'https://x.com/moneyball_ai',
} as const;

/** 프로필/아바타 이미지 로드 실패 시 사용할 로고 */
export const FALLBACK_AVATAR_LOGO = '/static/logo.png';
